import app from "flarum/forum/app";
import trustedHtml from "../../common/utils/trustedHtml";
import extractText from "flarum/common/utils/extractText";
import VerifiedBadge from "../../common/components/VerifiedBadge";
import getBadgeSvg, { getBadgeSize } from "../../common/utils/getBadgeSvg";
/**
 * Recursively find the first vnode in `node` whose attrs.className contains
 * the given class. Returns null if no match.
 */
export function findVnodeByClass(node, className) {
  if (!node || typeof node !== "object") return null;
  if (Array.isArray(node)) {
    for (const child of node) {
      const found = findVnodeByClass(child, className);
      if (found) return found;
    }
    return null;
  }
  const v = node;
  const cls = v.attrs && v.attrs.className;
  if (typeof cls === "string" && cls.split(/\s+/).indexOf(className) !== -1) {
    return v;
  }
  if (v.children) return findVnodeByClass(v.children, className);
  return null;
}

/**
 * Build a verified-badge vnode for use inside an avocado vnode tree.
 *
 * Returns the VerifiedBadge component when available, or falls back to a
 * plain <span> rendered via inline SVG if the component class isn't
 * accessible from this code path.
 */
export function makeVerifiedVnode(user, className) {
  if (!user || !user.isVerified || !user.isVerified()) return null;
  const Cls = (typeof VerifiedBadge === "function" ? VerifiedBadge : null) || (typeof flarum !== "undefined" && flarum.reg ? flarum.reg.get("ramon-verified", "common/components/VerifiedBadge") : null);
  if (typeof Cls === "function") {
    try {
      return m(Cls, {
        user,
        className
      });
    } catch (e) {
      // fall through to inline span
    }
  }
  let svg = getBadgeSvg();
  let size = "1.2em";
  let tooltip = "Verified";
  try {
    const z = getBadgeSize();
    if (typeof z === "string" && z) size = z;
    if (typeof app !== "undefined" && app.translator) {
      const t = extractText(app.translator.trans("ramon-verified.lib.tooltip"));
      if (t) tooltip = t;
    }
  } catch (e) {
    // defaults
  }
  return m("span", {
    className: ("VerifiedBadge " + (className || "")).trim(),
    style: {
      "--verified-size": size
    },
    role: "img",
    title: tooltip,
    "aria-label": tooltip
  }, trustedHtml(svg));
}
flarum.reg.add('ramon-verified', 'forum/utils/vnodeTree', { findVnodeByClass: findVnodeByClass,makeVerifiedVnode: makeVerifiedVnode, });